/**
 * Cashflow V2 shared formatting helpers and color tokens.
 */

export const colors = {
  accent: {
    teal: '#14b8a6',
    gold: '#f59e0b',
    indigo: '#818cf8',
  },
  status: {
    green: '#10b981',
    yellow: '#f59e0b',
    red: '#ef4444',
    blue: '#3b82f6',
    purple: '#8b5cf6',
  },
  chart: {
    areaFill: 'rgba(20, 184, 166, 0.15)',
    baseline: '#14b8a6',
    adjusted: '#818cf8',
    gridLine: '#e5e7eb',
  },
  bg: {
    card: '#ffffff',
    surface: '#f9fafb',
    dark: '#111827',
  },
  text: {
    primary: '#111827',
    secondary: '#6b7280',
    muted: '#9ca3af',
  },
}

export const STATUS_BAR_COLORS: Record<string, string> = {
  GREEN: colors.status.green,
  YELLOW: colors.status.yellow,
  RED: colors.status.red,
}

export const STATUS_BG_COLORS: Record<string, string> = {
  GREEN: 'bg-emerald-50 text-emerald-700',
  YELLOW: 'bg-amber-50 text-amber-700',
  RED: 'bg-red-50 text-red-700',
}

const currencyFmt = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
})

const compactFmt = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  notation: 'compact',
  maximumFractionDigits: 1,
})

const pctFmt = new Intl.NumberFormat('en-US', {
  style: 'percent',
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
})

const numFmt = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 0,
})

export const fmt = {
  currency: (value: number) => currencyFmt.format(value),
  compact: (value: number) => compactFmt.format(value),
  pct: (value: number) => pctFmt.format(value / 100),
  pctRaw: (value: number) => pctFmt.format(value),
  num: (value: number) => numFmt.format(value),
  shortDate: (raw: string) => {
    try {
      const date = new Date(raw)
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
    } catch {
      return raw
    }
  },
  weekLabel: (raw: string) => {
    try {
      const date = new Date(raw)
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
    } catch {
      return raw
    }
  },
}
